module.exports = __webpack_public_path__ + "yandex_kassa_qiwi.a1499cef22324c2eef2d141d84a61b34.png";